<cm-card [defaultThumbnail]="false">
    <ng-container cm-thumbnail>
        @if ($thumbnailObject(); as thumbnailData) {
            <cm-data-object-thumbnail [dataObjectId]="thumbnailData.id"></cm-data-object-thumbnail>
        } @else {
            @if ($thumbnailUrl(); as thumbnailData) {
                <cm-thumbnail [url]="thumbnailData"></cm-thumbnail>
            }
        }
    </ng-container>
    <ng-container cm-title>
        {{ $title() }}
    </ng-container>
</cm-card>
